import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../../../../components/ui/dialog";
import { Pencil } from "lucide-react";
import { AttendanceItem } from "../../../../models/attendance";
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAttendance as updateAttendanceApi } from "../../../../api/attendance";
import toastifyInstance from "../../../../utils/toastify";
import { DatePicker } from "../../../../components/ui/date-picker";

const UpdateAttendance = ({ data }: { data: AttendanceItem }) => {
    const [timeCheckIn, setTimeCheckIn] = useState('');
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date());

    const queryClient = useQueryClient();

    const updateAttendance = useMutation({
        mutationFn: async ({ checkTime, date }: { checkTime: Date, date: Date }) => {
            await updateAttendanceApi({
                uid: data.user._id,
                checkTime: checkTime.toISOString(),
                attendanceId: data?.attendance?._id || '',
                date: date.toISOString()
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['attendance'] });
            toastifyInstance.success('Attendance updated successfully');
        },
        onError: () => {
            toastifyInstance.error('Failed to update attendance');
        },
        onSettled: () => {
            setTimeCheckIn('');
            setSelectedDate(new Date());
        }
    })

    const handleUpdateAttendance = () => {
        if (!selectedDate) return;

        const [hours, minutes] = timeCheckIn ? timeCheckIn.split(":").map(Number) : [0, 0];
        // Create new date from selected date
        const checkInDate = new Date(selectedDate);
        // Cập nhật giờ, phút, giây và mili giây
        checkInDate.setHours(hours, minutes, 0, 0);

        updateAttendance.mutate({
            checkTime: checkInDate,
            date: selectedDate
        });
    }

    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="outline">
                    <Pencil className="text-blue-500" />
                </Button>
            </DialogTrigger>
            <DialogContent className="bg-white w-[max-content] min-w-[300px] max-w-[100%] h-[max-content]">
                <DialogHeader>
                    <DialogTitle>Update Attendance</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                    <div className="space-y-4">
                        <div>
                            <p className="text-sm font-medium mb-2">Date</p>
                            <DatePicker
                                date={selectedDate}
                                onChange={setSelectedDate}
                                endDate={new Date()}
                            />
                        </div>
                        <div>
                            <p className="text-sm font-medium mb-2">Time Check In</p>
                            <Input type="time" value={timeCheckIn} onChange={(e) => setTimeCheckIn(e.target.value)} />
                        </div>
                        <Button
                            className="w-full"
                            onClick={handleUpdateAttendance}
                            disabled={!selectedDate || !timeCheckIn}
                        >
                            Save
                        </Button>
                    </div>
                </DialogDescription>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateAttendance;